<template>
  <div style="height: 100%" class="main-page">
    <div v-if="notEnabled && loadingFinish" class="tip">
      <div>
        <a-icon type="car" />
        <span style="margin-left: 20px">该页面暂未启用~</span>
      </div>
      <div style="margin-top: 20px; font-size: 18px">
        提示：如有业务需求，可在“设置”页面---->"启用工序派工"
      </div>
    </div>
    <template v-if="!notEnabled && loadingFinish">
      <div class="top">
        <div class="top-header">
          <a-button @click="openDispatch" type="primary">
            {{ $t('page_plan_process_dispatch') }}
          </a-button>
          <div style="display: flex; align-items: center">
            <div style="display: flex; align-items: center">
              <div>{{ $t('page_resource_pool_status') }}：</div>
              <div>
                <a-tag
                  :color="assignStatusList.indexOf(0) != -1 ? 'blue' : ''"
                  @click="() => changeStatus(0)"
                >
                  {{ $t('page_job_process_dispatch_to_dispatched') }}
                </a-tag>
                <a-tag
                  :color="assignStatusList.indexOf(1) != -1 ? 'orange' : ''"
                  @click="() => changeStatus(1)"
                >
                  {{ $t('page_job_process_dispatch_dispatched') }}
                </a-tag>
              </div>
            </div>
            <a-button @click="openSearch">{{ $t('page_my_document_advanced') }}</a-button>
          </div>
        </div>
        <div class="top-body">
          <ml-table
            :columns="columnsList"
            :dataSource="dataList"
            :canChangeColWidth="true"
            :scroll="{ x: 500, y: 200 }"
            rowKey="id"
            :custom-row="rowClick"
            :row-selection="{
              selectedRowKeys,
              onChange: this.onSelectChange,
              type: 'radio'
            }"
          >
            <template slot="index" slot-scope="text, record, index">
              <span>{{ index + 1 }}</span>
            </template>
          </ml-table>
        </div>
      </div>
      <div class="bottom">
        <div class="bottom-left">
          <div class="bottom-left-top">{{ $t('page_plan_process_dispatch_situation') }}</div>
          <div>
            <ml-table
              :columns="columnsSituation"
              :dataSource="dataSituation"
              :canChangeColWidth="true"
              :scroll="{ x: tableScrollWidth, y: tableScrollY }"
              rowKey="id"
              :custom-row="rowClick2"
              :row-selection="{
                selectedRowKeys: selectedRowKey,
                onChange: this.onSelect,
                type: 'radio'
              }"
            >
              <template slot="index" slot-scope="text, record, index">
                <span>{{ index + 1 }}</span>
              </template>
            </ml-table>
          </div>
        </div>
        <div class="bottom-right">
          <div class="bottom-right-top">
            {{ $t('page_plan_process_dispatch_record') }}
          </div>
          <div>
            <ml-table
              :columns="columnsRecord"
              :dataSource="dataRecord"
              :canChangeColWidth="true"
              :scroll="{ x: tableScrollWidth, y: tableScrollY }"
            >
              <template slot="index" slot-scope="text, record, index">
                <span>{{ index + 1 }}</span>
              </template>
              <template slot="maintenance" slot-scope="text, record">
                <a-popconfirm
                  :title="$t('delete_tips')"
                  ok-text="Yes"
                  cancel-text="No"
                  @confirm="delectAdjustment(record)"
                  @cancel="cancel"
                >
                  <a
                    :style="{
                      color: record.assignStatus == 1 ? 'rgba(0,0,0,.25)' : 'red',
                      marginRight: '10px'
                    }"
                    :disabled="record.assignStatus == 1"
                    >{{ $t('delete') }}</a
                  >
                </a-popconfirm>

                <a @click="openAdjustment(record)" :disabled="record.assignStatus == 1">{{
                  $t('page_plan_process_adjustment')
                }}</a>
              </template>
            </ml-table>
          </div>
        </div>
      </div>
    </template>
    <dragModal
      :title="$t('page_my_document_advanced')"
      :subTitle="`(${$t('page_work_order_execution_operation_list')})`"
      :visible="searchVisible"
      top="130px"
      :confirm-loading="loading"
      @ok="handleOk"
      @cancel="handleSearchReset"
      @close="handleCancel"
    >
      <a-form-model ref="ruleForm" :model="form" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-model-item :label="$t('page_product_code') + ':'" prop="productCode">
          <a-input
            v-model="form.productCode"
            :placeholder="$t('common_please_input') + $t('page_product_code')"
          /> </a-form-model-item
        ><a-form-model-item :label="$t('page_plan_production_plan_no') + ':'" prop="planCode">
          <a-input
            v-model="form.planCode"
            :placeholder="$t('common_please_input') + $t('page_plan_production_plan_no')"
          /> </a-form-model-item
        ><a-form-model-item :label="$t('page_process_name') + ':'" prop="processName">
          <a-input
            v-model="form.processName"
            :placeholder="$t('common_please_input') + $t('page_process_name')"
          /> </a-form-model-item
        ><a-form-model-item
          :label="$t('page_standard_process_procedure_code') + ':'"
          prop="processCode"
        >
          <a-input
            v-model="form.processCode"
            :placeholder="$t('common_please_input') + $t('page_standard_process_procedure_code')"
          />
        </a-form-model-item>
        <a-form-model-item :label="$t('page_plan_plan_start_time') + ':'" prop="planStartTime">
          <a-date-picker
            v-model="form.planStartTime"
            type="date"
            :placeholder="$t('please_select') + $t('page_plan_plan_start_time')"
            style="width: 100%"
          />
        </a-form-model-item>
        <a-form-model-item :label="$t('page_plan_plan_end_time') + ':'" prop="planEndTime">
          <a-date-picker
            v-model="form.planEndTime"
            type="date"
            :placeholder="$t('please_select') + $t('page_plan_plan_end_time')"
            style="width: 100%"
          />
        </a-form-model-item>
      </a-form-model>
    </dragModal>
    <Dispatch
      :visible="dispatchVisable"
      @closeDispatch="closeDispatch"
      :assignInfo="assignInfo"
      :poProcessId="poProcessId"
    />
    <a-modal
      :title="$t('page_plan_process_dispatch_adjustment')"
      :visible="adjustmentVisible"
      :confirm-loading="loading"
      @cancel="djustmentCancel"
    >
      <div>
        <a-form-model :model="adjustmentList">
          <a-row>
            <a-col :span="12">
              <a-form-model-item :label="$t('page_material_warehousing_order_code') + ':'">
                <span>{{ adjustmentList.planCode }}</span>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="12">
              <a-form-model-item :label="$t('page_process_name') + ':'">
                <span>{{ adjustmentList.processName }}</span>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item :label="$t('page_standard_process_procedure_code') + ':'">
                <span>{{ adjustmentList.processCode }}</span>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="12">
              <a-form-model-item :label="$t('page_plan_craft_Sequence') + ':'">
                <span>{{ adjustmentList.processSequence }}</span>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item :label="$t('page_product_process_sequence') + ':'">
                <span>{{ adjustmentList.sort }}</span>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="12">
              <a-form-model-item :label="$t('page_plan_process_assigned_quantity') + ':'">
                <span>{{ adjustmentList.assignNum }}</span>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item :label="$t('page_plan_process_quantity_to_be_assigned') + ':'">
                <span>{{ adjustmentList.unassignedNum }}</span>
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-form-model>
      </div>
      <div>
        <ml-table
          :columns="adjustmentColumns"
          :dataSource="adjustmentData"
          :canChangeColWidth="true"
          :scroll="{ x: 500, y: 300 }"
        >
          <template slot="assignNum" slot-scope="text, record">
            <a-input
              type="number"
              v-model="record.assignNum"
              :min="0"
              @change="changeNum(record, text)"
            />
          </template>
          <template slot="planStartTime" slot-scope="text, record">
            <a-date-picker v-model="record.planStartTime" type="date" style="width: 100%" />
          </template>
        </ml-table>
      </div>
      <div slot="footer">
        <a-button @click="djustmentCancel" style="margin-top: 5px">{{ $t('cancel') }}</a-button>
        <a-button @click="djustmentOk" type="primary" style="margin-top: 5px">{{
          $t('submit')
        }}</a-button>
      </div>
    </a-modal>
  </div>
</template>

<script>
import Dispatch from './components/dispatch'
import {
  ProductionOrderProcessServiceProxy,
  ProductionOrderProcessAssignServiceProxy,
  ProductionOrderProcessAssignRecordServiceProxy
} from '@/service-proxies/app-v2/coproduction.service-proxies'
import dayjs from 'dayjs'
import { ProductionPlanTypeServiceProxy } from '@/service-proxies/app-v2/coproduction.service-proxies'
const productionOrderProcessServiceProxy = new ProductionOrderProcessServiceProxy()
const productionOrderProcessAssignServiceProxy = new ProductionOrderProcessAssignServiceProxy()
const productionOrderProcessAssignRecordServiceProxy =
  new ProductionOrderProcessAssignRecordServiceProxy()
const productionPlanTypeServiceProxy = new ProductionPlanTypeServiceProxy()
export default {
  components: { Dispatch },
  data() {
    return {
      dataList: [],
      dataSituation: [],
      dataRecord: [],
      searchVisible: false,
      loading: false,
      labelCol: { span: 6 },
      wrapperCol: { span: 17 },
      dispatchVisable: false,
      adjustmentVisible: false,
      form: {
        productCode: '',
        planCode: '',
        processName: '',
        processCode: '',
        planStartTime: '',
        planEndTime: ''
      },
      adjustmentList: {
        planCode: '',
        processName: '',
        processCode: '',
        assignNum: '',
        unassignedNum: '',
        sort: null,
        processSequence: ''
      },
      adjustmentData: [],
      selectedRowKeys: [],
      selectedRowKey: [],
      poProcessId: '',
      ProcessId: '',
      adjustmentId: '',
      assignInfo: [],
      // canSureVisible: false,
      tableScrollWidth: 500,
      tableScrollY: 270,
      resizeTimer: null,
      // 工序派工页面是否启用
      notEnabled: true,
      // 是否调用接口判断页面启用完毕
      loadingFinish: false,
      assignStatusList: [0, 1]
    }
  },
  created() {
    productionPlanTypeServiceProxy.getProductionPlanTypeInfo().then((res) => {
      const info = res.find((re) => re.id == this.$route.path[this.$route.path.length - 1]) || {}
      this.notEnabled = info.processAssignMode === 0
      this.loadingFinish = true
    })
    this.getProcessAssignList()
  },
  watch: {
    selectedRowKeys: {
      handler(val) {
        if (val.length > 0) {
          this.poProcessId = val[0]
          this.getAssignList(val[0])
          this.getAssignRecordList(val[0], '')
        }
      }
    }
  },
  computed: {
    columnsList() {
      return [
        {
          title: this.$t('page_resource_pool_no'),
          dataIndex: 'index',
          ellipsis: true,
          width: 50,
          scopedSlots: { customRender: 'index' }
        },
        {
          title: this.$t('page_product_code'),
          dataIndex: 'productCode',
          ellipsis: true,
          width: 80
        },
        {
          title: this.$t('page_product_name'),
          dataIndex: 'productName',
          ellipsis: true,
          width: 80
        },
        {
          title: this.$t('page_plan_production_plan_no'),
          dataIndex: 'planCode',
          ellipsis: true,
          width: 100
        },
        {
          title: this.$t('page_plan_process_order_code'),
          dataIndex: 'planOrderCode',
          ellipsis: true,
          width: 100
        },
        {
          title: this.$t('page_plan_order_no'),
          dataIndex: 'orderCode',
          ellipsis: true,
          width: 100
        },
        {
          title: this.$t('page_standard_process_procedure_code'),
          dataIndex: 'processCode',
          ellipsis: true,
          width: 100
        },
        {
          title: this.$t('page_process_name'),
          dataIndex: 'processName',
          ellipsis: true,
          width: 100
        },
        {
          title: this.$t('page_workstation_maintain_station_name'),
          dataIndex: 'workStationName',
          ellipsis: true,
          width: 100
        },
        {
          title: this.$t('page_work_order_input_num'),
          dataIndex: 'inputNum',
          ellipsis: true,
          width: 80
        },
        {
          title: this.$t('page_work_order_report_num'),
          dataIndex: 'reportNum',
          ellipsis: true,
          width: 80
        },
        {
          title: this.$t('page_work_order_qulify_num'),
          dataIndex: 'qualifyNum',
          ellipsis: true,
          width: 80
        },
        {
          title: this.$t('page_work_order_scrapped_num'),
          dataIndex: 'scrappedNum',
          ellipsis: true,
          width: 80
        },
        {
          title: this.$t('page_plan_process_assigned_quantity'),
          dataIndex: 'assignNum',
          ellipsis: true,
          width: 80
        },
        {
          title: this.$t('page_plan_process_quantity_to_be_assigned'),
          dataIndex: 'unassignedNum',
          ellipsis: true,
          width: 80
        },
        {
          title: this.$t('page_collection_quantity'),
          dataIndex: 'collectionNum',
          ellipsis: true,
          width: 80
        },
        {
          title: this.$t('page_plan_process_dispatch_status'),
          dataIndex: 'assignStatus',
          ellipsis: true,
          width: 100,
          customRender: (val) => (val == '0' ? '待派工' : '已派工')
        },
        {
          title: this.$t('page_plan_plan_start_time'),
          dataIndex: 'planStartTime',
          ellipsis: true,
          width: 120,
          customRender: (time) => (time ? dayjs(time).format('YYYY-MM-DD') : '')
        },
        {
          title: this.$t('page_plan_plan_end_time'),
          dataIndex: 'planEndTime',
          ellipsis: true,
          width: 120,
          customRender: (time) => (time ? dayjs(time).format('YYYY-MM-DD') : '')
        }
      ]
    },
    columnsSituation() {
      return [
        {
          title: this.$t('page_resource_pool_no'),
          dataIndex: 'index',
          ellipsis: true,
          width: 50,
          scopedSlots: { customRender: 'index' }
        },
        {
          title: this.$t('page_process_name'),
          dataIndex: 'processName',
          ellipsis: true,
          width: 100
        },
        {
          title: this.$t('page_workstation_management'),
          dataIndex: 'workStationName',
          ellipsis: true,
          width: 100
        },
        {
          title: this.$t('page_plan_process_production_team'),
          dataIndex: 'assignDeptName',
          ellipsis: true,
          width: 100
        },
        {
          title: this.$t('page_plan_process_production_personnel'),
          dataIndex: 'producerName',
          ellipsis: true,
          width: 100,
          customRender: (val) => (val ? val : '-')
        },
        {
          title: this.$t('page_plan_process_total_assigned'),
          dataIndex: 'totalNum',
          ellipsis: true,
          width: 80
        },
        {
          title: this.$t('page_work_order_report_num'),
          dataIndex: 'reportNum',
          ellipsis: true,
          width: 80
        },
        {
          title: this.$t('page_plan_wait_report_num'),
          dataIndex: 'unreportNum',
          ellipsis: true,
          width: 80
        },
        {
          title: this.$t('page_collection_quantity'),
          dataIndex: 'collectionNum',
          ellipsis: true,
          width: 80
        },
        {
          title: this.$t('page_station_capacity'),
          dataIndex: 'workstationCapacity',
          ellipsis: true,
          width: 80
        }
      ]
    },
    columnsRecord() {
      return [
        {
          title: this.$t('page_resource_pool_no'),
          dataIndex: 'index',
          ellipsis: true,
          width: 50,
          scopedSlots: { customRender: 'index' }
        },
        {
          title: this.$t('edit'),
          dataIndex: 'maintenance',
          ellipsis: true,
          width: 100,
          scopedSlots: { customRender: 'maintenance' }
        },
        {
          title: this.$t('page_resource_pool_status'),
          dataIndex: 'assignStatus',
          ellipsis: true,
          width: 80,
          customRender: (val) => (val == '0' ? '未完成' : '已完成')
        },
        {
          title: this.$t('page_process_name'),
          dataIndex: 'processName',
          ellipsis: true,
          width: 100
        },
        {
          title: this.$t('page_workstation_management'),
          dataIndex: 'workStationName',
          ellipsis: true,
          width: 100
        },
        {
          title: this.$t('page_plan_process_production_team'),
          dataIndex: 'assignDeptName',
          ellipsis: true,
          width: 100
        },
        {
          title: this.$t('page_plan_process_production_personnel'),
          dataIndex: 'producerName',
          ellipsis: true,
          width: 100,
          customRender: (val) => (val ? val : '-')
        },
        {
          title: this.$t('page_plan_process_assigned_quantity'),
          dataIndex: 'assignNum',
          ellipsis: true,
          width: 80
        },
        {
          title: this.$t('page_work_order_report_num'),
          dataIndex: 'reportNum',
          ellipsis: true,
          width: 80
        },
        {
          title: this.$t('page_collection_quantity'),
          dataIndex: 'collectionNum',
          ellipsis: true,
          width: 80
        },
        {
          title: this.$t('page_station_capacity'),
          dataIndex: 'workstationCapacity',
          ellipsis: true,
          width: 80
        },
        {
          title: this.$t('page_plan_predict_start_time'),
          dataIndex: 'planStartTime',
          ellipsis: true,
          width: 120,
          customRender: (time) => (time ? dayjs(time).format('YYYY-MM-DD') : '')
        },
        {
          title: this.$t('page_plan_predict_end_time'),
          dataIndex: 'planEndTime',
          ellipsis: true,
          width: 120,
          customRender: (time) => (time ? dayjs(time).format('YYYY-MM-DD') : '')
        },
        {
          title: this.$t('page_plan_process_assigned_time'),
          dataIndex: 'assignTime',
          ellipsis: true,
          width: 120,
          customRender: (time) => (time ? dayjs(time).format('YYYY-MM-DD') : '')
        }
      ]
    },
    adjustmentColumns() {
      return [
        {
          title: this.$t('page_qc_product_workstaion'),
          dataIndex: 'workStationName',
          ellipsis: true,
          width: 100
        },
        {
          title: this.$t('page_plan_process_production_team'),
          dataIndex: 'assignDeptName',
          ellipsis: true,
          width: 100
        },
        {
          title: this.$t('page_plan_process_production_personnel'),
          dataIndex: 'producerName',
          ellipsis: true,
          width: 100,
          customRender: (val) => (val ? val : '-')
        },
        {
          title: this.$t('page_plan_process_assigned_quantity'),
          dataIndex: 'assignNum',
          ellipsis: true,
          width: 80,
          scopedSlots: { customRender: 'assignNum' }
        },
        {
          title: this.$t('page_plan_process_quantity_already_sent'),
          dataIndex: 'hasAssignNum',
          ellipsis: true,
          width: 80
        },
        {
          title: this.$t('page_work_order_report_num'),
          dataIndex: 'reportNum',
          ellipsis: true,
          width: 80
        },
        {
          title: this.$t('page_plan_wait_report_num'),
          dataIndex: 'unreportNum',
          ellipsis: true,
          width: 80
        },
        {
          title: this.$t('page_collection_quantity'),
          dataIndex: 'collectionNum',
          ellipsis: true,
          width: 80
        },
        {
          title: this.$t('page_station_capacity'),
          dataIndex: 'stationProductionCapacity',
          ellipsis: true,
          width: 80
        },
        {
          title: this.$t('page_plan_predict_start_time'),
          dataIndex: 'planStartTime',
          ellipsis: true,
          width: 150,
          scopedSlots: { customRender: 'planStartTime' }
        },
        {
          title: this.$t('page_plan_predict_end_time'),
          dataIndex: 'planEndTime',
          ellipsis: true,
          width: 150,
          customRender: (time) => (time ? dayjs(time).format('YYYY-MM-DD') : '')
        }
      ]
    }
  },
  methods: {
    changeStatus(number) {
      if (this.assignStatusList.indexOf(number) != -1) {
        const list = [...this.assignStatusList]
        this.assignStatusList = list.filter((res) => res != number)
      } else {
        this.assignStatusList.push(number)
      }
      this.selectedRowKeys = []
      this.getProcessAssignList()
    },
    async getProcessAssignList() {
      // this.selectedRowKeys = [];
      let params = {
        assignStatusList: this.assignStatusList,
        planCode: this.form.planCode,
        planEndTime: this.form.planEndTime ? dayjs(this.form.planEndTime).format('YYYY-MM-DD') : '',
        planStartTime: this.form.planStartTime
          ? dayjs(this.form.planStartTime).format('YYYY-MM-DD')
          : '',
        processCode: this.form.processCode,
        processName: this.form.processName,
        productCode: this.form.productCode,
        typeId: this.$route.path[this.$route.path.length - 1]
      }
      let res = await productionOrderProcessServiceProxy.processAssignList(params)
      this.dataList = res
      if (this.dataList.length > 0 && this.selectedRowKeys.length < 1) {
        this.selectedRowKeys.push(this.dataList[0].id)
      }
    },
    async getAssignList(id) {
      this.selectedRowKey = []
      let res = await productionOrderProcessAssignServiceProxy.getAssignList({
        poProcessId: id
      })
      this.dataSituation = res
    },
    async getAssignRecordList(poProcessId, assignId) {
      let params = {
        assignDeptId: '',
        assignId: assignId ? assignId : '',
        poProcessId: poProcessId ? poProcessId : '',
        producerDeptId: '',
        producerId: ''
      }
      let res = await productionOrderProcessAssignRecordServiceProxy.getAssignRecordList(params)
      this.dataRecord = res
    },
    async getAssignRecord() {
      this.adjustmentData = []
      let res = await productionOrderProcessAssignRecordServiceProxy.getAssignRecord(
        this.adjustmentId
      )
      this.adjustmentData.push(res.assignRecordDetailDTO)
      if (this.adjustmentData.length > 0 && this.adjustmentData[0].planStartTime) {
        this.adjustmentData[0].planStartTime = dayjs(this.adjustmentData[0].planStartTime).format(
          'YYYY-MM-DD'
        )
      }
      this.adjustmentList.planCode = res.planCode
      this.adjustmentList.processName = res.processName
      this.adjustmentList.processCode = res.processCode
      this.adjustmentList.assignNum = res.assignNum
      this.adjustmentList.unassignedNum = res.unassignedNum
      this.adjustmentList.sort = res.sort
      this.adjustmentList.processSequence = res.processSequence
      this.adjustmentList.workstationCapacity = res.workstationCapacity
    },
    async deleteAssignRecord() {
      await productionOrderProcessAssignRecordServiceProxy.deleteAssignRecord(this.adjustmentId)
      this.$message.success('删除成功')
      this.getAssignRecordList(this.poProcessId, this.ProcessId)
    },
    async updateAssignRecord() {
      if (this.adjustmentData.length > 0) {
        let params = {
          assignNum: this.adjustmentData[0].assignNum,
          id: this.adjustmentData[0].id,
          planEndTime: dayjs(this.adjustmentData[0].planEndTime).format('YYYY-MM-DD'),
          planStartTime: this.adjustmentData[0].planStartTime
        }
        await productionOrderProcessAssignRecordServiceProxy
          .updateAssignRecord(params)
          .then((res) => {
            this.$message.success('调整成功')
            this.getProcessAssignList()
            this.getAssignList(this.poProcessId)
            this.getAssignRecordList(this.poProcessId, this.ProcessId)
            this.adjustmentVisible = false
            // this.canSureVisible = false
          })
      }
    },
    async processAssignInfo() {
      let res = await productionOrderProcessServiceProxy.processAssignInfo(this.selectedRowKeys[0])
      this.assignInfo = res
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.poProcessId = selectedRows[0].id
      this.getAssignList(selectedRows[0].id)
      this.getAssignRecordList(selectedRows[0].id, '')
    },
    onSelect(selectedRowKeys, selectedRows) {
      this.selectedRowKey = selectedRowKeys
      this.getAssignRecordList(this.poProcessId, selectedRows[0].id)
      this.ProcessId = selectedRows[0].id
    },
    openSearch() {
      this.searchVisible = !this.searchVisible
    },
    handleOk() {
      this.selectedRowKeys = []
      this.getProcessAssignList()
      // this.searchVisible = false;
    },
    // 高级搜索重置
    handleSearchReset() {
      this.$refs.ruleForm.resetFields()
    },
    handleCancel() {
      // this.$refs.ruleForm.resetFields();
      this.searchVisible = false
    },
    openDispatch() {
      this.processAssignInfo()
      this.dispatchVisable = true
    },
    closeDispatch() {
      this.getProcessAssignList()
      this.getAssignList(this.poProcessId)
      this.getAssignRecordList(this.poProcessId, this.ProcessId)
      this.dispatchVisable = false
    },
    openAdjustment(record) {
      this.adjustmentId = record.id
      this.getAssignRecord()
      this.adjustmentVisible = true
    },
    delectAdjustment(record) {
      this.adjustmentId = record.id
      this.deleteAssignRecord()
    },
    djustmentOk() {
      this.updateAssignRecord()
    },
    djustmentCancel() {
      this.adjustmentVisible = false
    },
    cancel(e) {
      console.log(e)
    },
    changeNum(record, i) {
      if (parseInt(i) < 0) {
        record.assignNum = 0
      }
    },
    canSureOk() {
      this.updateAssignRecord()
    },
    // canSureCancel(){
    //  this.canSureVisible = false
    // },
    rowClick(record) {
      return {
        on: {
          click: (event) => {
            this.poProcessId = record.id
            this.selectedRowKeys = []
            this.selectedRowKeys.push(record.id)
          }
        }
      }
    },
    rowClick2(record) {
      return {
        on: {
          click: (event) => {
            this.ProcessId = record.id
            this.selectedRowKey = []
            this.selectedRowKey.push(record.id)
            this.getAssignRecordList(this.poProcessId, this.ProcessId)
          }
        }
      }
    },
    scrollY() {
      let pHeight =
        document.querySelector('.main-page') && document.querySelector('.main-page').clientHeight
      this.tableScrollY = pHeight - 420 - 20
    }
  },
  mounted() {
    this.scrollY()
    window.onresize = () => {
      clearTimeout(this.resizeTimer)
      this.resizeTimer = setTimeout(() => {
        this.scrollY()
      }, 500)
    }
  },
  beforeDestroy() {
    window.onresize = null
  }
}
</script>

<style lang="less" scoped>
.tip {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: rgb(215, 215, 215);
  font-size: 48px;
  font-weight: bold;
}
.top {
  height: 50%;
  width: 100%;
  background-color: #fff;
  .top-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 8px 0;
  }
}
.bottom {
  height: 48%;
  margin-top: 10px;
  width: 100%;
  display: flex;
  .bottom-left {
    width: 49.5%;
    height: 100%;
    margin-right: 5px;
    background-color: #fff;
    .bottom-left-top {
      width: 80px;
      height: 30px;
      border: 1px solid;
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 8px 0;
    }
  }
  .bottom-right {
    height: 100%;
    width: 49.5%;
    margin-left: 7px;
    background-color: #fff;
    .bottom-right-top {
      width: 80px;
      height: 30px;
      border: 1px solid;
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 8px 0;
    }
  }
}
/deep/ .ant-row .ant-form-item {
  display: flex;
}
/deep/ .ant-modal-content {
  width: 1000px;
  margin-left: -100px;
}
</style>
